import {ChangeDetectionStrategy, Component, computed, inject, Signal} from "@angular/core";
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {LogoComponent} from "../../ui-elements/logo/logo.component";
import {BackgroundImageDirective} from '../../ui-elements/image/background-image.directive';
import {ConfigurationModel} from '../../configuration/configuration.model';

/**
 * Standard page header image component
 */
@Component({
    selector: "woa-page-header-image",
    templateUrl: "./page-header-image.component.html",
    styleUrls: ["./page-header-image.component.scss", "../../ui-elements/image/background-image.scss"],
    imports: [
        BackgroundImageDirective,
        LogoComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderImageComponent {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    public configurationModel: ConfigurationModel = inject(ConfigurationModel);

    public showPageLogo: Signal<boolean> = computed(() => this.configurationModel.app()?.showMobileHeaderVerticalLogo);
}
